module.exports = __webpack_public_path__ + "img/girl-running.7e34fcae.png";